import React from 'react';
import { Global, css } from '@emotion/core';
import { neutral50, neutral300, neutral500, neutral0, neutral1000 } from '@fever/ui';
function GlobalCss({ fontFamily }) {
    /* yahoo tracking 會在 body 下插入一個 img 元素來發請求，但會導致 body 高度變化，
       在 iframe embed 的情況下會導致高度不精確
    */
    const yahooTrackingCssBug = `
        body > img[src*="sp.analytics.yahoo.com"] {
            position: absolute;
            bottom: 0;
        }
    `;
    return (
        <Global
            styles={css`
                html,
                body,
                #root {
                    height: 100%;
                }
                body {
                    margin: 0;
                    font-family: ${fontFamily};
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    letter-spacing: 0.1em;
                }

                * {
                    box-sizing: border-box;
                }

                ${yahooTrackingCssBug}

                // scrollbar custom css
                .trackYVisible {
                    .ScrollbarsCustom-Wrapper {
                        right: 0px !important;
                    }
                }

                .ScrollbarsCustom-Track {
                    background: ${neutral50} !important;
                    border-radius: 4px !important;
                }

                .ScrollbarsCustom-Thumb {
                    background: ${neutral300} !important;
                    border-radius: 4px !important;
                    &:hover {
                        background: ${neutral500} !important;
                    }
                }

                /* Mui Global Css */
                .MuiButtonBase-root.Mui-disabled,
                .MuiSelect-select.Mui-disabled,
                .MuiInputBase-input.Mui-disabled {
                    cursor: not-allowed;
                }
                .MuiButtonBase-root.Mui-disabled {
                    pointer-events: initial;
                }
                .MuiTooltip-tooltip {
                    padding: 8px;
                    color: ${neutral0};
                    background-color: ${neutral1000};
                    & .MuiTooltip-arrow {
                        color: ${neutral1000};
                    }
                }
            `}
        />
    );
}

export default GlobalCss;
